import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/components/ui/dialog'
import type { ChatMember } from '@/entities/chat'

export function MessageInfo({
  others,
  messageId,
  open,
  onOpenChange,
}: {
  others: ChatMember[]
  messageId: number
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  const read = others.filter((m) => m.lastReadMessageId != null && m.lastReadMessageId >= messageId)
  const delivered = others.filter(
    (m) =>
      m.lastDeliveredMessageId != null &&
      m.lastDeliveredMessageId >= messageId &&
      !read.some((r) => r.userId === m.userId && r.name === m.name),
  )

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[360px]">
        <DialogHeader>
          <DialogTitle>Message info</DialogTitle>
        </DialogHeader>
        <Section title="Read by" members={read} />
        <Section title="Delivered to" members={delivered} />
      </DialogContent>
    </Dialog>
  )
}

function Section({ title, members }: { title: string; members: ChatMember[] }) {
  return (
    <div className="space-y-1">
      <p className="text-[11px] font-semibold uppercase tracking-wide text-ink-4">{title}</p>
      {members.length === 0 ? (
        <p className="text-[13px] text-ink-3">No one yet</p>
      ) : (
        members.map((member) => (
          <p key={`${member.role}-${member.userId ?? member.name}`} className="text-[13px] text-ink-2">
            {member.name}
          </p>
        ))
      )}
    </div>
  )
}
